export const CLEAR_ANALYSIS_DATA = 'CLEAR_ANALYSIS_DATA';